<template>
  <a-layout>
    <a-layout-content style="background-color:white">
      <a-row class="vd-toolbar">
        <a-col class="vd-toolbar-right vd-bar">
          <a-form layout="inline">
            <a-form-item label="姓名">
              <a-input placeholder="推广员姓名"/>
            </a-form-item>
            <a-form-item label="编号">
              <a-input placeholder="推广员编号"/>
            </a-form-item>
            <a-form-item label="时间区间">
              <a-range-picker :default-value="defaultTime" format="YYYY/MM/DD" @change="dateChange"/>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" icon="search"/>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>

      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="增长统计" :bordered="true">
            <div id="userChart" style="height: 300px;width: 400px"></div>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="消息统计" :bordered="true">
            <div id="messageChart" style="height: 300px;width: 400px"></div>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="内容分析" :bordered="true">
            <div>1231</div>
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="推送记录" :bordered="true">
            <div>1231</div>
          </a-card>
        </a-col>
      </a-row>

    </a-layout-content>
  </a-layout>
</template>

<script>
  import { user_chart, message_chart } from '@/api'
  import moment from 'moment'
  import * as echarts from 'echarts'

  export default {
    name: 'DetailMonth',
    data () {
      return {
        defaultTime: [moment().startOf('week'), moment().endOf('week')],
        // -------------
        id: 0,
        countList: [],
        userChart: null,
        messageChart: null,
      }
    },
    created () {
      this.id = this.$route.query.id
    },
    mounted () {
      this.userChart = echarts.init(document.getElementById('userChart'))
      this.messageChart = echarts.init(document.getElementById('messageChart'))
      this.getData()
    },
    methods: {
      drawUser (refDate, newUser, cancelUser, cleanUser) {
        // 绘制图表
        this.userChart.setOption({
          title: false,
          tooltip: { trigger: 'axis' },
          legend: {
            data: ['净增', '关注', '取关'],
            selected: { '关注': false, '取关': false },
          },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: { type: 'category', boundaryGap: false, data: refDate },
          yAxis: { type: 'value' },
          series: [
            { name: '净增', type: 'line', stack: '总量', smooth: true, data: newUser },
            { name: '关注', type: 'line', stack: '总量2', smooth: true, data: cleanUser },
            { name: '取关', type: 'line', stack: '总量3', smooth: true, data: cancelUser },
          ],
        })
        this.userChart.resize()
      },
      drawMessage (refDate, messageCount) {
        // 绘制图表
        this.messageChart.setOption({
          title: false,
          tooltip: { trigger: 'axis' },
          legend: { data: ['消息数'] },
          grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
          xAxis: { type: 'category', boundaryGap: false, data: refDate },
          yAxis: { type: 'value' },
          series: [{ name: '消息数', type: 'line', stack: '总量', smooth: true, data: messageCount }],
        })
        this.messageChart.resize()
      },
      getData () {
        // 用户 chart
        user_chart({ id: this.id, time_range: this.defaultTime }).then(res => {
          if (res['code'] === 1) {
            this.drawUser(res.list.ref_date, res.list.new_user, res.list.cancel_user, res.list.clean_user)
          } else {
            this.$message.warning(res.msg)
          }
        })
        // 消息 chart
        message_chart({ id: this.id, time_range: this.defaultTime }).then(res => {
          if (res['code'] === 1) {
            this.drawMessage(res.list.ref_date, res.list.msg_count)
          } else {
            this.$message.warning(res.msg)
          }
        })
      },
      dateChange (dates) {
        this.defaultTime = dates
      },

    },
  }
</script>

<style scoped>

</style>